// extracted by mini-css-extract-plugin
export var boldText = "_3t-4";
export var checkboxContainer = "_3t-6";
export var closeIcon = "_3t-i";
export var container = "_3t-0";
export var drawer = "_3t-8";
export var drawerContent = "_3t-9";
export var extraSmallText = "_3t-5";
export var fulfillmentGroupTable = "_3t-e";
export var largeText = "_3t-3";
export var loadingSpinnerContainer = "_3t-j";
export var mediumText = "_3t-2";
export var narrow = "_3t-f";
export var notificationLink = "_3t-l";
export var packageCheckIconContainer = "_3t-7";
export var slideoutHeaderActions = "_3t-g";
export var slideoutHeaderActionsShifted = "_3t-h";
export var slideoutHeaderContainer = "_3t-a";
export var slideoutModal = "_3t-c";
export var stickyHeaderWrapper = "_3t-b";
export var table = "_3t-k";
export var tableContainer = "_3t-d";
export var tertiaryText = "_3t-1";